import { render, staticRenderFns } from "./PmtaSpeed.vue?vue&type=template&id=372620fd&scoped=true"
import script from "./PmtaSpeed.vue?vue&type=script&lang=js"
export * from "./PmtaSpeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372620fd",
  null
  
)

export default component.exports